
import { Component, Mixins } from "vue-property-decorator";
import { IImeControllable } from "../../../../../domain/document/items";
import { ImeModeKinds } from "../../../../../domain/document";

@Component({
})
export default class ImeControllableMixin extends Mixins() {
  readPropertyOrDefault: <T>(reader: (source: IImeControllable) => T, defaultValue: T) => T;

  get imeModeProperties() {
    // IEではIMEの状態を制御できる模様。Chromeでは制御できない。
    return {
      imeMode: this.imeModeStyleValue,
    };
  }

  get imeModeStyleValue(): string {
    switch (this.imeMode) {
      case ImeModeKinds.Off:
        return "inactive";
      case ImeModeKinds.On:
        return "auto";
      case ImeModeKinds.AllOn:
        return "active";
    }
    return "auto";
  }

  get imeMode(): ImeModeKinds {
    return this.readPropertyOrDefault(s => s.imeMode, ImeModeKinds.On);
  }
}
